<template>
  <div v-if="info !== null" class="main">
    <div style="position: relative;" class="main-box">
      <div class="back"></div>
      <div class="content">
        <div class="content-top">
          <div class="usersInfo">
            <img :src="result.avatar" class="avatar" />
            <div class="name">
              <div>{{ result.uname }}</div>
            </div>
          </div>
          <div class="content-top-box">
            <div class="title">{{ info.title }}</div>
            <div class="submit-success" v-if="info.temp == 3">
            <!-- <icon type="success" color="#1890FF" size="50" /> -->
            <div class="success-text">提交成功</div>
          </div>
          <div v-else>
            <div class="hide-score" v-if="info.hide_score">
              <!-- <icon type="success" color="#1890FF" size="50" /> -->
              <div class="tip">提交成功，出题人设置隐藏成绩</div>
            </div>
            <div v-else>
              <div class="score">{{ result.score }}</div>
              <div class="all">
                满分{{
                  result.full_score
                }}分
              </div>
            </div>
          </div>
          </div>
        </div>
        <div class="content-body" v-if="info.temp != 3">
          <div class="detail">
            <div v-if="info.hide_score" class="time-box">
              <div>答题用时</div>
              <div class="big">{{ result.time }}</div>
            </div>
            <div v-else>
              <div class="top">
                <div class="top-view">
                  <div class="big" style="color:#00cf97">
                    {{ result.right + result.wrong }}
                  </div>
                  <div class="tip">总题数</div>
                </div>
                <div class="top-view">
                  <div class="big" style="color:#ff7070">
                    {{ result.wrong }}
                  </div>
                  <div class="tip">答错</div>
                </div>
                <div v-if="info.temp == 2" class="top-view">
                  <div class="big">{{ result.total_days }}</div>
                  <div class="tip black">累计答题(天)</div>
                </div>
                <div v-else class="top-view">
                  <div class="big black">
                    {{
                      result.right + result.wrong == 0
                        ? 0
                        : (
                            (result.right / (result.right + result.wrong)) *
                            100
                          ).toFixed(1)
                    }}%
                  </div>
                  <div class="tip">正确率</div>
                </div>
                <div class="top-view">
                  <div class="big">{{ result.time }}</div>
                  <div class="tip">用时</div>
                </div>
              </div>
              <!-- <div class="bottom">
                <div class="tip" style="margin:0">
                  {{ info.temp == 1 ? "练习" : "" }}用时
                </div>
                <div class="big black">{{ result.time }}</div>
              </div> -->
            </div>
          </div>
        </div>

        <div class="button">
          <van-button
            class="btn blue"
            type="primary"
            size="large"
            @click="toDo()"
            >再答一次</van-button
          >
        </div>
      </div>
      <HomeIcon position="right" />
    </div>
  </div>
</template>

<script>
import { timestampToDate, setShareInfo } from "@/utils/common";
import HomeIcon from "@/components/homeIcon";

export default {
  components: { HomeIcon },
  data() {
    return {
      info: null,
      result: null,
      rid: ""
    };
  },
  mounted() {
    this.rid = this.$route.query.rid;
    this.getInfo();
    setShareInfo(false);
  },
  destroy() {
    if (localStorage.getItem("tryResult")) {
      localStorage.removeItem("tryResult");
    }
  },
  methods: {
    // 评论跳转至公众号
    toWebview() {
      let url = this.info.adv_comment.url;
      if (url) {
        window.location.href = this.info.adv_comment.url;
      }
    },
    toDo() {
      this.$router.go(-1);
    },
    getInfo() {
      let tryResult = JSON.parse(localStorage.getItem("tryResult"));
      if (tryResult) {
        this.info = tryResult;
        this.result = tryResult.submit_data;
        this.result.time = timestampToDate(tryResult.submit_data.time);
      }
    }
  }
};
</script>

<style scoped lang="scss">
@function rem($px) {
  @return $px * 2 / 75 + rem;
}

.main {
  min-height: 100vh;
  // background: #fff;
  color: #262626;
  .main-box {
    max-width: 500px;
    margin: 0 auto;
    position: relative;
  }
  .back {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 280px;
    background: linear-gradient(0deg, rgba(24, 144, 255, 0) 0%, rgb(24, 144, 255) 36%, rgb(24, 144, 255) 100%);
    max-width: 500px;
    margin: 0 auto;
  }
  .content {
    min-width: 345px;
    margin: 0 auto 0;
    border-radius: 5px;
    position: relative;
    // padding-bottom: rem(15);
    line-height: 1;
    text-align: center;
    padding-top: 23px;
  }


  @media screen and (max-width: 500px) {
    // 小于500
    .content {
      max-width: 460px;
    }
  }

  @media screen and (max-width: 450px) {
    // 小于450
    .content {
      max-width: 390px;
    }
  }

  @media screen and (max-width: 400px) {
    // 小于400
    .content {
      max-width: 360px;
    }
  }
  @media screen and (max-width: 380px) {
    // 小于400
    .content {
      max-width: 350px;
    }
  }

  @media screen and (min-width: 500px) {
    // 大于500
    .content {
      max-width: 460px;
    }
  }
  .content-body {
    background-color: #fff;
    margin-top: 10px;
    border-radius: 6px;
  }
  .name {
    font-size: 15px;
    margin-left: 15px;
    display: flex;
    align-items: center;
  }

  .name div {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 126px;
  }

  .name img {
    width: 15px;
    height: 15px;
    padding: 7px;
  }

  .title {
    font-weight: bold;
    font-size: 17px;
    padding: 0 15px;
    line-height: 1.4;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    color: #262626;
  }

  .score {
    font-weight: bold;
    font-size: 42px;
    margin: 20px 0 18px;
    color: #1890ff;
  }
  .success-icon {
    width: 50px;
    height: 50px;
    object-fit: cover;
    margin-top: 30px;
    margin-bottom: 11px;
  }

  .avatar {
    width: 45px;
    height: 45px;
    border-radius: 50%;
    border: 2px solid #fff;
  }

  .all {
    color: #999;
    font-size: 13px;
  }
  .detail {
    margin: auto;
  }
  .bottom,
  .top {
    display: flex;
    display: -webkit-flex;
    justify-content: space-between;
    align-items: center;
  }

  .top {
    padding: 20px 15px;
  }
  .top-view {
    flex: 1;
    justify-content: space-between;
    text-align: center;
  }
  .top-view:first-child {
    max-width: 60px;
  }

  
  .bottom {
    padding: 15px 15px 20px;
    margin: 0 auto;
    border-top: 1px solid #ccc;
    /* width: 540rpx; */
  }

  .tip {
    font-size: 13px;
    color: #999;
    margin-top: 5px;
    line-height: 19px;
  }

  .big {
    font-size: 17px;
    font-weight: bold;
    line-height: 25px;
  }

  .action {
    position: relative;
    display: flex;
    display: -webkit-flex;
    flex-wrap: wrap;
    justify-content: space-between;
    padding: 0 15px;
  }
  .blue {
    border-color: #1890ff;
    background: #1890ff;
  }
  .button {
    margin-top: 20px;
    font-size: 16px;
    border-radius: 4px;
  }
  .mp-box {
    display: flex;
    align-items: center;
    font-size: rem(14);
    columns: #666;
    margin: rem(15);
    padding: rem(10);
    background-color: #f5f5f5;
  }
  .mp-box img {
    width: rem(45);
    height: rem(45);
    margin-right: rem(10);
    object-fit: cover;
  }
  .mp-box view {
    flex: 1;
    line-height: 1.5;
    text-align: left;

    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
  .comment-text {
    margin: 0 rem(15) rem(15);
    background-color: #f5f5f5;
    padding: rem(15);
    font-size: ren(15);
    line-height: 1.5;
    border-radius: rem(5);
    color: #262626;
  }
  .comment-text text {
    max-width: 100%;
  }
  .comment-text img {
    display: block;
    margin: rem(15) auto 0;
    width: rem(285);
    height: rem(160);
    object-fit: cover;
  }
}
.black {
  color: #262626;
}
.usersInfo {
  display: flex;
  color: #fff;
}
.content-top-box {
  background-color: #ffffff;
  text-align: center;
  padding: 23px 15px 20px;
  border-radius: 6px;
  margin-top: 20px;
}
.time-box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 64px;
  background: #fff;
  color: #262626;
  padding: 0 15px;
}
.time-box .left {
  color: #999999;
  font-size: 13px;
}

</style>



// WEBPACK FOOTER //
// src/pages/normal/resultTry.vue